import {
  EnhancedBlandWorkflowStatus,
  NormalizedEvaluationSchema,
} from '@/types/enhanced-bland-call';

// Status emoji mapping consistent with summary card
export const getStatusEmoji = (status: EnhancedBlandWorkflowStatus) => {
  switch (status) {
    case EnhancedBlandWorkflowStatus.CALL_IN_PROGRESS:
      return '📞';
    case EnhancedBlandWorkflowStatus.THINKING:
      return '🤔';
    case EnhancedBlandWorkflowStatus.WAITING:
      return '😴';
    case EnhancedBlandWorkflowStatus.FAILED_READY_CHECK:
      return '⚠️';
    case EnhancedBlandWorkflowStatus.COMPLETED:
      return '🏁';
    case EnhancedBlandWorkflowStatus.FAILED:
    case EnhancedBlandWorkflowStatus.FAILED_INELIGIBLE:
      return '❌';
    case EnhancedBlandWorkflowStatus.STARTED:
      return '🚦';
    default:
      return '🤖';
  }
};

export const formatDuration = (seconds: number | undefined): string => {
  if (!seconds) return 'N/A';
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${mins}m ${secs}s`;
};

export const formatDate = (
  dateString: string | undefined,
  options: { fromNow?: boolean } = {},
): string => {
  if (!dateString) return 'Unknown';
  const date = new Date(dateString);

  if (options.fromNow) {
    const now = new Date();
    const diffHours = Math.floor(
      (now.getTime() - date.getTime()) / (1000 * 60 * 60),
    );

    if (diffHours < 1) return 'Just now';
    if (diffHours < 24) return `${diffHours}h ago`;
    return date.toLocaleDateString();
  }

  return date.toLocaleString();
};

export const getCallSuccessIcon = (
  evaluation: NormalizedEvaluationSchema | null | undefined,
) => {
  if (!evaluation) return '';
  const { success_status } = evaluation;
  switch (success_status) {
    case 'success':
    case 'full_success':
      return '✓';
    case 'partial_success':
      return '!';
    case 'no_success':
    case 'failure':
      return '';
    case 'unclear':
    case 'uncontrollable':
    default:
      return '';
  }
};
